import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GenericHttp } from './generic-http.service';
import { Config } from '@config/config.service';
import { OfferInfo, OfferRoadmapStep } from '@features/profile/offer/offer-info/offer-info.interface';

@Injectable()
export class OfferApiService {
  private offerInfoUrl: string;
  private offerFilesUrl: string;
  private offerDataUrl: string;
  private offerTableFilterDataUrl: string;
  private offerEmailUrl: string;
  private setOfferAssigneeUrl: string;
  private offerSaleSessionlUrl: string;
  private changeOfferProductUrl: string;
  private offerNotificationSaleSessionlUrl: string;
  private editOfferStatusUrl: string;
  private changeOfferCommentUrl: string;
  private updateOfferMetadataUrl: string;
  private offerAllFilesUrl: string;
  private changeOfferUrl: string;
  private editOfferSessionUrl: string;
  private scoreDiscountUrl: string;
  private requestScoreDiscountUrl: string;
  private requestScoreDiscountV2Url: string;
  private agentPrivateOfferTextUrl: string;
  private offerHistoryChangesUrl: string;
  private offerEventsUrl: string;
  private getStatusRoadmapUrl: string;
  private offerCommentsUrl: string;
  private offerDeclineReasonsUrl: string;
  private previousCompaniesUrl: string;
  private ofvVariantsApiUrl: string;
  private carBrandsApiUrl: string;
  private carModelsApiUrl: string;
  private carModelYearsApiUrl: string;
  private carModelRegYearsApiUrl: string;
  private carModelVariantApiUrl: string;
  private brokrPartnerListUrl: string;
  private offerPermissionsUrl: string;
  private permissionsUrl: string;
  private updateTiaPriceUrl: string;
  private offerFetchOfferPriceUrl: string;
  private saveEditProductTiaUrl: string;
  private randPrimeUrl: string;
  private defaultPropertiesUrl: string;
  private dynamicPropertiesUrl: string;
  private offerCompleteNotificationlUrl: string;
  private focusAcceptUrl: string;
  private hierarchyKonseptsUrl: string;
  private hierarchyGrupperingerUrl: string;
  private hierarchyTypesUrl: string;
  private hierarchyDefaultsUrl: string;

  constructor(
    private trbhttp: GenericHttp,
    private config: Config,
  ) {
    this.offerInfoUrl = config.offerInfoUrl;
    this.offerFilesUrl = config.offerFilesUrl;
    this.offerDataUrl = config.offerDataUrl;
    this.offerTableFilterDataUrl = config.offerTableFilterDataUrl;
    this.offerEmailUrl = config.offerEmailUrl;
    this.setOfferAssigneeUrl = config.setOfferAssigneeUrl;
    this.offerSaleSessionlUrl = config.offerSaleSessionlUrl;
    this.changeOfferProductUrl = config.changeOfferProductUrl;
    this.offerNotificationSaleSessionlUrl = config.offerNotificationSaleSessionlUrl;
    this.editOfferStatusUrl = config.editOfferStatusUrl;
    this.changeOfferCommentUrl = config.changeOfferCommentUrl;
    this.updateOfferMetadataUrl = config.updateOfferMetadataUrl;
    this.offerAllFilesUrl = config.offerAllFilesUrl;
    this.changeOfferUrl = config.changeOfferUrl;
    this.editOfferSessionUrl = config.editOfferSessionUrl;
    this.scoreDiscountUrl = config.scoreDiscountUrl;
    this.requestScoreDiscountUrl = config.requestScoreDiscountUrl;
    this.requestScoreDiscountV2Url = config.requestScoreDiscountV2Url;
    this.agentPrivateOfferTextUrl = config.agentPrivateOfferTextUrl;
    this.offerHistoryChangesUrl = config.offerHistoryChangesUrl;
    this.offerEventsUrl = config.offerEventsUrl;
    this.getStatusRoadmapUrl = config.getStatusRoadmapUrl;
    this.offerDeclineReasonsUrl = config.offerDeclineReasonsUrl;
    this.previousCompaniesUrl = config.previousCompaniesUrl;
    this.ofvVariantsApiUrl = config.ofvVariantsApiUrl;
    this.carBrandsApiUrl = config.carBrandsApiUrl;
    this.carModelsApiUrl = config.carModelsApiUrl;
    this.carModelYearsApiUrl = config.carModelYearsApiUrl;
    this.carModelRegYearsApiUrl = config.carModelRegYearsApiUrl;
    this.carModelVariantApiUrl = config.carModelVariantApiUrl;
    this.offerCommentsUrl = config.offerCommentsUrl;
    this.brokrPartnerListUrl = config.brokrPartnerListUrl;
    this.permissionsUrl = config.permissionsUrl;
    this.offerPermissionsUrl = config.offerPermissionsUrl;
    this.updateTiaPriceUrl = config.updateTiaPriceUrl;
    this.offerFetchOfferPriceUrl = config.offerFetchOfferPriceUrl;
    this.saveEditProductTiaUrl = config.saveEditProductTiaUrl;
    this.randPrimeUrl = config.randPrimeUrl;
    this.defaultPropertiesUrl = config.defaultPropertiesUrl;
    this.dynamicPropertiesUrl = config.dynamicPropertiesUrl;
    this.offerCompleteNotificationlUrl = config.offerCompleteNotificationlUrl;
    this.focusAcceptUrl = config.focusAcceptUrl;
    this.hierarchyKonseptsUrl = config.hierarchyKonseptsUrl;
    this.hierarchyGrupperingerUrl = config.hierarchyGrupperingerUrl;
    this.hierarchyTypesUrl = config.hierarchyTypesUrl;
    this.hierarchyDefaultsUrl = config.hierarchyDefaultsUrl;
  }

  focusAccept(offerId: string): Observable<OfferInfo> {
    const url = this.focusAcceptUrl.replace('{offerId}', offerId);

    return this.trbhttp.put(url, {});
  }

  getDefaultProperties(offerId: string): Observable<any> {
    const url = this.defaultPropertiesUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  getDynamicProperties(): Observable<any> {
    return this.trbhttp.get(this.dynamicPropertiesUrl);
  }

  getPermissions(): Observable<any> {
    return this.trbhttp.get(this.permissionsUrl);
  }

  getOfferPermissions(offerId: string): Observable<any> {
    const url = this.offerPermissionsUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  getBrokrPartnersList(offerId: string): Observable<any> {
    const url = this.brokrPartnerListUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  updateSelectedBrokrPartnersList(offerId: string, partnerListId: any[]): Observable<any> {
    const url = this.brokrPartnerListUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, partnerListId);
  }

  getCarBrands(): Observable<any> {
    return this.trbhttp.get(this.carBrandsApiUrl);
  }

  getCarModels(brandId): Observable<any> {
    const url = this.carModelsApiUrl.replace('{brandId}', brandId);

    return this.trbhttp.get(url);
  }

  getCarModelRegYears(brandId, modelId): Observable<any> {
    const url = this.carModelRegYearsApiUrl.replace('{brandId}', brandId).replace('{modelId}', modelId);

    return this.trbhttp.get(url);
  }

  getCarModelYears(brandId, modelId, regYearId): Observable<any> {
    const url = this.carModelYearsApiUrl.replace('{brandId}', brandId).replace('{modelId}', modelId).replace('{regYearId}', regYearId);

    return this.trbhttp.get(url);
  }

  getCarModelVariant(brandId, modelId, regYearId, modelYearId): Observable<any> {
    const url = this.carModelVariantApiUrl.replace('{brandId}', brandId)
      .replace('{modelId}', modelId).replace('{regYearId}', regYearId).replace('{modelYearId}', modelYearId);

    return this.trbhttp.get(url);
  }

  getOfvVariantsList(carRegNo: string, forceUseCarRegisterData = false): Observable<any> {
    const url = this.ofvVariantsApiUrl.replace('{carRegNo}', carRegNo);

    if (forceUseCarRegisterData) {
      return this.trbhttp.get(url, {forceUseCarRegisterData});
    }

    return this.trbhttp.get(url);
  }

  getPreviousCompanies(): Observable<string[]> {
    return this.trbhttp.get(this.previousCompaniesUrl);
  }

  getHierarchyKonsepts(): Observable<string[]> {
    return this.trbhttp.get(this.hierarchyKonseptsUrl);
  }

  getHierarchyGrupperinger(konsept: string): Observable<string[]> {
    const url = this.hierarchyGrupperingerUrl.replace('{konsept}', konsept);

    return this.trbhttp.get(url);
  }

  getHierarchyTypes(konsept: string, gruppering: string): Observable<string[]> {
    const url = this.hierarchyTypesUrl.replace('{gruppering}', gruppering);

    return this.trbhttp.get(url, { konsept });
  }

  getHierarchyDefaults(): Observable<any> {
    return this.trbhttp.get(this.hierarchyDefaultsUrl);
  }

  getAgentPrivateOfferText(offerShortGuid: string): Observable<any> {
    const url = this.agentPrivateOfferTextUrl.replace('{offerShortGuid}', offerShortGuid);

    return this.trbhttp.get(url);
  }

  getOfferHistory(offerId: string): Observable<any> {
    const url = this.offerHistoryChangesUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  getOfferEvents(offerId: string): Observable<any> {
    const url = this.offerEventsUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  getStatusRoadmap(offerId: string): Observable<OfferRoadmapStep[]> {
    const url = this.getStatusRoadmapUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  getOfferComments(offerId: string): Observable<any> {
    const url = this.offerCommentsUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  getOfferDeclineReasons(shortGuid: string): Observable<any> {
    const url = this.offerDeclineReasonsUrl.replace('{shortGuid}', shortGuid);

    return this.trbhttp.get(url);
  }

  editOfferSession(offerId: string, data: any, queryParams: any): Observable<any> {
    const url = this.editOfferSessionUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(
      url,
      data,
      queryParams
    );
  }

  getScoreDiscountData(shortGuid: string): Observable<any> {
    const url = this.scoreDiscountUrl.replace('{shortGuid}', shortGuid);

    return this.trbhttp.get(url);
  }

  changeScoreDiscountData(shortGuid: string): Observable<any> {
    // TODO: Make one endpoint when contemi will be ready
    const url =
      this.config.contemiCPSlogic ?
      this.requestScoreDiscountV2Url.replace('{shortGuid}', shortGuid) :
      this.requestScoreDiscountUrl.replace('{shortGuid}', shortGuid);

    return this.trbhttp.post(url);
  }

  getOfferTableFilterData(filterData): Observable<any> {
    return this.trbhttp.post(
      this.offerTableFilterDataUrl,
      filterData
    );
  }

  getOffers(dataPage, dataLimit): Observable<any> {
    return this.trbhttp.get(
      this.offerDataUrl,
      { page: dataPage, limit: dataLimit }
    );
  }

  getOfferInfo(offerId: string): Observable<OfferInfo> {
    const url = this.offerInfoUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  getOfferFiles(offerId: string): Observable<any> {
    const url = this.offerFilesUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  getAllOfferFiles(offerId: string): Observable<any> {
    const url = this.offerAllFilesUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  setOfferAssigneeUser(offerId: string, data: any): Observable<any> {
    const url = this.setOfferAssigneeUrl.replace('{offerId}', offerId);

    return this.trbhttp.put(url, data);
  }

  editOfferStatus(offerId: string, data: any): Observable<any> {
    const url = this.editOfferStatusUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  changeOfferComment(offerId: string, data: any): Observable<any> {
    const url = this.offerCommentsUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  changeOfferMetadata(offerId: string, data: any): Observable<any> {
    const url = this.updateOfferMetadataUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  sendOfferEmail(offerId, data): Observable<any> {
    const url = this.offerEmailUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  setOfferSaleSession(data): Observable<any> {
    return this.trbhttp.post(this.offerSaleSessionlUrl, data);
  }

  sendOfferNotificationSaleSession(offerId: string, data): Observable<any> {
    const url = this.offerNotificationSaleSessionlUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  sendOfferCompleteNotification(offerId: string, data): Observable<any> {
    const url = this.offerCompleteNotificationlUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  editOfferProduct(offerId: string, data): Observable<any> {
    const url = this.changeOfferProductUrl.replace('{offerId}', offerId);

    return this.trbhttp.put(url, data);
  }

  editOffer(offerId: string, data): Observable<any> {
    const url = this.changeOfferUrl.replace('{id}', offerId);

    return this.trbhttp.post(url, data);
  }

  updateTiaPrice(offerId: string, data): Observable<any> {
    const url = this.updateTiaPriceUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  fetchOfferPriceCalculation(offerId: string): Observable<any> {
    const url = this.offerFetchOfferPriceUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url);
  }

  patchRandPrime(offerId: string, data): Observable<OfferInfo> {
    const url = this.randPrimeUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  saveEditProductTia(offerId: string, data): Observable<any> {
    const url = this.saveEditProductTiaUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  addOfferProduct(offerId: string, data): Observable<any> {
    const url = this.changeOfferProductUrl.replace('{offerId}', offerId);

    return this.trbhttp.post(url, data);
  }

  deleteOfferProduct(offerId: string, data): Observable<any> {
    const url = this.changeOfferProductUrl.replace('{offerId}', offerId);

    return this.trbhttp.del(url, data);
  }
}
